import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  inject,
} from '@angular/core';
import { ScreenSizes } from '../../classes/screen-sizes.class';
import { tooltipDelay } from '../../consts';
import { debounce } from '../../lib/debounce';
import { TooltipService } from '../../services/tooltip.service';
import { TooltipOptions, tooltipStyle } from '../../types/tooltip';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
})
export class TooltipDirective implements OnChanges, OnDestroy {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
  private tooltipService = inject(TooltipService);
  @Input('appTooltip') text = '';
  @Input() tooltipKeyboardShortcut: string;
  @Input() tooltipKeyboardShortcutMeta: boolean;
  @Input() tooltipStyle: tooltipStyle;
  @Input() tooltipTitle: string;
  @Input() tooltipImageOrVideoUrl: string;
  @Input() toolTipOrigin: TooltipOptions['position'];
  @Input() skipDelay = false;
  @Input() showOnMobile = false;
  @Output() onShow = new EventEmitter<void>();
  private hovering: boolean;
  private destroyed = false;
  private showing = false;

  ngOnChanges() {
    if (this.showing) this._show();
  }

  @HostListener('mouseenter')
  show() {
    this.hovering = true;
    if (this.skipDelay) this._show();
    else this.showDebounced();
  }

  showDebounced = debounce(() => {
    this._show();
  }, tooltipDelay);

  private _show() {
    if (!this.showOnMobile && ScreenSizes.screenSize() === 'mobile') return;
    if (!this.hovering) return;
    if (this.destroyed) return;

    this.onShow.emit();

    const assetIsVideo = this.tooltipImageOrVideoUrl?.includes('.mp4');

    const imageUrl = assetIsVideo ? undefined : this.tooltipImageOrVideoUrl;
    const videoUrl = assetIsVideo ? this.tooltipImageOrVideoUrl : undefined;

    this.showing = true;
    this.tooltipService.show(this.text, this.elementRef.nativeElement, {
      style: this.tooltipStyle || 'dark',
      position: this.toolTipOrigin || 'top',
      title: this.tooltipTitle,
      imageUrl,
      videoUrl,
      keyboardShortcut: this.tooltipKeyboardShortcut,
      keyboardShortcutMeta: this.tooltipKeyboardShortcutMeta,
    });
  }

  @HostListener('mouseleave')
  mouseleave() {
    this.hovering = false;
    this.tooltipService.hide();
  }

  ngOnDestroy() {
    if (this.showing) this.tooltipService.hide();
    this.destroyed = true;
  }
}
